"use client";

import { useFieldContext } from "@/shared/forms/form-context";
import { LoincCodePicker } from "@/shared/pickers/loinc-code-picker";

export interface LoincCodeFieldProps {
  disabled?: boolean;
  placeholder?: string;
  onSelect?: (code: string, display: string) => void;
}

export function LoincCodeField({ disabled, placeholder, onSelect }: LoincCodeFieldProps) {
  const field = useFieldContext<{ code: string; display: string } | undefined>();

  return (
    <LoincCodePicker
      value={field.state.value}
      onChange={(v) => {
        field.handleChange(v);
        field.handleBlur();
        if (v?.code && onSelect) onSelect(v.code, v.display);
      }}
      disabled={disabled}
      placeholder={placeholder}
    />
  );
}
